import React from 'react';

import styled from 'styled-components';

const BADGE_BACKGROUND_COLORS = ['#f2f7d9', '#d3ebf4', '#fce3db'] as const;

const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
`;

const Badge = styled.span<{ $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 16px;
  border-radius: 2px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: var(--stile-grey-7);
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  white-space: nowrap;
`;

type LessonBadgeRowProps = {
  badges: string[];
} & React.HTMLAttributes<HTMLDivElement>;

export default function LessonBadgeRow({ badges, className, ...props }: LessonBadgeRowProps) {
  return (
    <BadgeRow className={className} {...props}>
      {badges.map((label, index) => (
        <Badge
          key={label}
          $backgroundColor={BADGE_BACKGROUND_COLORS[index % BADGE_BACKGROUND_COLORS.length]}
        >
          {label}
        </Badge>
      ))}
    </BadgeRow>
  );
}
